import React from 'react';
import { Callout, List, P, Steps, Sub, Table, UI } from '../ui';

export const Calls: React.FC = () => (
  <>
    <P>
      1:1 대화방과 그룹 대화방에서 영상 통화를 걸 수 있습니다. 통화 중에 화면 공유, 녹화, 화이트보드, 채팅을 함께
      쓸 수 있어 간단한 회의를 그대로 진행할 수 있습니다.
    </P>

    <Sub>통화 걸기</Sub>
    <Steps>
      <>
        1:1 또는 그룹 대화방을 엽니다. <b>공지 채널과 나와의 채팅에는 통화 버튼이 없습니다.</b>
      </>
      <>
        대화창 오른쪽 위의 <UI>통화</UI> 버튼(카메라 모양)을 누릅니다.
      </>
      <>
        카메라와 마이크 사용 권한을 묻는 창이 뜨면 허용합니다. <b>통화를 시작하면 카메라와 마이크가 함께 켜집니다.</b>{' '}
        얼굴을 보이고 싶지 않다면 연결된 뒤 카메라 끄기 버튼을 누르세요. 카메라나 마이크가 없어도 통화할 수 있습니다
        (아래 &lsquo;카메라·마이크가 없을 때&rsquo;).
      </>
      <>
        대화방에 있는 사람 모두에게 전화가 갑니다. 그 대화방을 열어 두지 않고 다른 방을 보고 있어도 울립니다. 상대가
        받으면 화면이 연결됩니다.
      </>
    </Steps>
    <P>
      그 대화방에서 이미 통화가 진행 중이면 새 통화를 걸지 않고 진행 중인 통화에 들어갑니다. 한 대화방에는 통화가 하나만
      열립니다.
    </P>

    <Sub>걸려 온 전화 받기</Sub>
    <P>
      화면 오른쪽 위에 발신자의 사진과 이름이 담긴 배너가 나타나고 신호음이 2초 간격으로 울립니다. 초록색 버튼은
      받기, 빨간색 버튼은 거절입니다.
    </P>
    <List>
      <>PC 앱에서는 작업표시줄 아이콘이 함께 깜빡이고, 웹에서는 브라우저 탭 제목이 번갈아 바뀝니다.</>
      <>
        PC와 노트북에 함께 로그인해 두었다면 양쪽 모두 울리다가, <b>한쪽에서 받거나 거절하는 순간 나머지 기기의
        신호음이 꺼집니다.</b>
      </>
      <>이미 다른 통화를 하고 있는 기기에서는 울리지 않습니다.</>
      <>
        아무도 받지 않으면 건 사람 화면에 30초 뒤 <UI>상대방이 응답하지 않습니다.</UI>가 뜨고 통화가 끝납니다. 그룹
        통화에서 누군가 이미 받았다면, 받지 않은 사람의 신호음은 <b>45초 뒤 꺼지고</b> 부재중으로 바뀝니다. 통화가
        계속되고 있으면 대화방 위의 <UI>통화 중 · 참여</UI>로 언제든 들어갈 수 있습니다.
      </>
    </List>

    <Sub>여러 명이 통화할 때</Sub>
    <List>
      <>
        그룹 대화방에서는 <b>최대 6명</b>까지 함께 통화할 수 있습니다. 6명이 차면 대화방 위에
        <UI>인원이 가득 찼습니다(최대 6명)</UI>가 표시됩니다.
      </>
      <>
        통화가 진행 중인 대화방을 열면 위쪽에 <UI>통화 중 · 김철수 외 2명</UI>과 <UI>참여</UI> 버튼이 보입니다. 전화를
        놓쳤거나 거절했어도 이 버튼으로 들어갈 수 있고, 늦게 들어와도 먼저 와 있던 모든 사람의 화면과 소리가 연결됩니다.
      </>
      <>
        <b>빨간 버튼은 나만 나가기</b>입니다. 그룹 통화는 다른 사람들이 계속 통화하고, 마지막 사람이 나가면 끝납니다.
        혼자 남은 상태가 10분 이어지면 자동으로 끝납니다. 1:1 통화는 한쪽이 끊으면 바로 끝납니다.
      </>
      <>
        그룹 통화에서 누군가 거절해도 통화는 계속됩니다. 모두가 거절하거나 아무도 받지 않으면 끝납니다.
      </>
      <>
        누군가 화면을 공유하면 그 화면이 크게 보이고 나머지 사람은 아래 줄에 작게 나옵니다. 크게 보이는 화면을 누르면
        원래 배치로 돌아가고, 다른 사람의 화면을 누르면 그 사람을 크게 봅니다.
      </>
      <>
        인원이 많아지면 각자의 화질이 자동으로 조금씩 낮아집니다. 각 PC가 자기 영상을 다른 참가자 수만큼 따로 보내기
        때문입니다.
      </>
      <>
        연결이 잠깐 끊겨도(Wi-Fi 전환 등) 20초 안에 돌아오면 통화가 그대로 이어집니다. 그 사이 상대 화면에는
        <UI>다시 연결 중…</UI>이 보입니다.
      </>
    </List>

    <Sub>통화 중에 초대하기</Sub>
    <P>
      통화하는 도중에 사람을 더 부를 수 있습니다. 그룹 대화방 통화와 1:1 통화 모두 됩니다.
    </P>
    <Steps>
      <>
        통화 화면 아래의 <UI>초대</UI> 버튼(사람 모양)을 누릅니다. 상대가 한 명이라도 통화에 들어온 뒤에 보입니다.
      </>
      <>
        부를 사람을 고르고 <UI>초대</UI>를 누릅니다. 이름이나 부서로 찾을 수 있습니다.
      </>
      <>
        고른 사람에게 바로 신호음이 갑니다. 통화 화면 위쪽에 <UI>김철수 호출 중</UI>이 보이고, 받으면 사라집니다.
        거절하거나 45초 동안 받지 않으면 초대한 사람에게 안내가 뜹니다.
      </>
    </Steps>
    <List>
      <>
        <b>이 대화방 멤버</b>: 그룹 대화방에서 아직 통화에 들어오지 않은 멤버입니다. 거절했거나 놓친 사람도 다시
        부를 수 있습니다.
      </>
      <>
        <b>다른 사람</b>(1:1 통화에서는 <b>초대할 사람</b>): 이 대화방 멤버가 아닌 동료입니다. 이 사람은{' '}
        <b>대화방에 추가되지 않고 이 통화에만 게스트로 들어옵니다.</b> 대화방의 지난 대화를 볼 수 없고, 통화가
        끝나면 그 대화방과의 연결도 끝납니다.
      </>
      <>
        통화에 있는 사람과 호출 중인 사람을 합쳐 <b>최대 6명</b>까지 부를 수 있습니다. 한 사람은 한 통화에서 세 번까지
        다시 부를 수 있습니다.
      </>
      <>
        1:1 통화에 게스트가 들어와 세 명이 되면, 한 명이 나가도 남은 두 사람은 계속 통화합니다. 혼자 남으면 끝납니다.
      </>
    </List>
    <Callout tone="info" title="게스트로 초대받았을 때">
      <p>
        신호음 배너에 <UI>화상 통화 초대</UI>와 <UI>○○○님의 통화</UI>가 표시됩니다. 받으면 통화 화면 위쪽에{' '}
        <UI>게스트</UI>가 붙습니다.
      </p>
      <p>
        게스트는 그 대화방 멤버가 아니라서 통화 화면의 채팅·녹화·초대 버튼이 없습니다. 영상·소리·화면 공유·화이트보드는
        다른 참가자와 똑같이 쓸 수 있습니다.
      </p>
      <p>
        PC 앱이 오래된 버전이면 게스트로 초대할 수 없습니다(<UI>상대가 PC 앱을 업데이트하면 초대할 수 있습니다.</UI>).
      </p>
    </Callout>

    <Sub>통화 화면</Sub>
    <Table
      head={['버튼', '기능']}
      rows={[
        ['음소거', '내 마이크를 끕니다. 끈 상태는 상대 화면의 내 이름 옆에 표시됩니다'],
        ['카메라', '내 영상을 끕니다. 상대 화면에는 이름 첫 글자가 적힌 동그라미가 보입니다'],
        ['화면 공유', '내 화면이나 특정 창을 상대에게 보여줍니다'],
        ['녹화', '통화를 영상 파일로 남깁니다(게스트에게는 없음)'],
        ['화이트보드', '함께 그릴 수 있는 칠판을 엽니다'],
        ['채팅', '통화 중인 대화방의 대화창을 통화 화면 오른쪽에 엽니다(게스트에게는 없음)'],
        ['초대', '통화 중에 사람을 더 부릅니다(위 ‘통화 중에 초대하기’)'],
        ['빨간 버튼', '나가기(1:1은 한 명만 남으면 통화 종료)'],
      ]}
    />
    <P>
      화면 위쪽에 대화방 이름, 통화 경과 시간, 참가자 수가 표시되고, 내 영상은 오른쪽 아래에 작게 나옵니다. 참가자 수에
      따라 화면이 자동으로 분할됩니다.
    </P>
    <P>
      위쪽의 <UI>최소화</UI> 버튼을 누르면 통화가 오른쪽 아래 작은 카드로 줄어들어, 통화를 유지한 채 다른 대화방을
      볼 수 있습니다. 줄여 둔 동안에도 상대 소리는 계속 들립니다. 카드를 클릭하면 다시 원래 크기로 돌아옵니다.
    </P>

    <Sub>카메라·마이크가 없을 때</Sub>
    <P>
      카메라나 마이크가 없거나, 다른 프로그램이 쓰고 있거나, 사용 권한을 허용하지 않았어도 통화는 연결됩니다. 쓸 수
      있는 것만 켜고, <b>둘 다 쓸 수 없으면 보기 전용</b>으로 들어가 상대의 영상·화면 공유·소리를 그대로 보고
      듣습니다.
    </P>
    <List>
      <>통화 화면이 열리기 전에 무엇이 빠졌는지 안내가 잠깐 뜹니다.</>
      <>
        쓸 수 없는 장치의 버튼은 회색으로 바뀌고 <UI>카메라 없음</UI>·<UI>마이크 없음</UI>으로 표시됩니다. 둘 다
        없으면 화면 위쪽에 <UI>보기 전용</UI>이 붙습니다.
      </>
      <>카메라가 없으면 상대에게는 내 이름 첫 글자가 적힌 동그라미가 보입니다. 화면 공유는 카메라가 없어도 쓸 수 있습니다.</>
      <>마이크가 없으면 내 목소리는 전달되지 않습니다. 채팅 버튼으로 대화창을 열어 글로 이야기하세요.</>
      <>통화 중에 장치를 연결하거나 권한을 허용해도 바로 켜지지 않습니다. 통화를 끊고 다시 걸거나 받으면 켜집니다.</>
    </List>

    <Sub>화면 공유</Sub>
    <P>
      화면 공유를 누르면 공유할 화면이나 창을 고르는 창이 뜹니다. 공유하는 동안 상대에게는 내 카메라 영상 대신 공유
      화면이 보이고, 공유를 멈추면 자동으로 카메라 영상으로 돌아옵니다(카메라가 없으면 이름 동그라미로 돌아옵니다).
    </P>
    <Callout tone="warn">
      <p>
        <b>소리는 공유되지 않습니다.</b> 영상 자료를 함께 볼 때는 소리가 상대에게 전달되지 않는 점을 감안하세요.
      </p>
      <p>휴대폰이나 일부 브라우저처럼 화면 공유를 지원하지 않는 환경에서는 버튼 자체가 보이지 않습니다.</p>
    </Callout>

    <Sub>통화 녹화</Sub>
    <P>
      빨간 동그라미 버튼을 누르면 녹화가 시작되고 화면 위쪽에 경과 시간이 표시됩니다. 다시 누르면 녹화가 끝나며,{' '}
      <b>영상 파일이 자동으로 대화방에 올라갑니다.</b>
    </P>
    <Callout tone="danger" title="녹화는 참가자 모두에게 표시됩니다">
      <p>
        누군가 녹화를 시작하면 <UI>○○○ 녹화 중</UI> 표시가 참가자 전원의 화면에 나타납니다. 몰래 녹화할 수는
        없습니다.
      </p>
      <p>
        <b>녹화 파일은 통화 중인 대화방으로 올라갑니다.</b> 다른 방을 보고 있다가 통화 화면의 채팅 버튼을 누르면 통화
        중인 대화방이 열립니다.
      </p>
      <p>녹화 중에 앱이 갑자기 종료되면 그때까지의 영상은 저장되지 않습니다.</p>
    </Callout>

    <Sub>화이트보드</Sub>
    <P>
      연필 모양 버튼을 누르면 영상 위에 그림판이 열립니다. <b>내가 열면 상대 화면에도 함께 열립니다.</b> 펜과
      지우개, 색상 8가지, 굵기 4단계를 쓸 수 있고 마우스와 터치 모두 지원합니다.
    </P>
    <P>선을 하나 긋고 마우스를 떼는 순간 상대 화면에 나타납니다. 화면 크기가 서로 달라도 같은 위치에 그려집니다.</P>
    <Callout tone="warn" title="화이트보드 사용 시 알아둘 점">
      <p>
        <b>되돌리기는 내 화면에서만</b> 적용되고 상대 화면에는 그대로 남습니다. 모두 지우려면 전체 지우기를 쓰세요
        (전체 지우기는 참가자 모두에게 적용됩니다).
      </p>
      <p>
        <b>그린 내용은 저장되지 않습니다.</b> 닫았다 다시 열면 백지가 되고, 통화가 끝나면 사라집니다. 남겨야 할
        내용은 화면 캡처로 저장해 대화방에 올려두세요.
      </p>
      <p>통화 도중에 들어온 사람은 그 전에 그려진 내용을 볼 수 없습니다.</p>
    </Callout>

    <Sub>통화 종료</Sub>
    <P>
      전화가 올 때 어느 기기로 알림이 가는지는 <b>알림</b> 항목에서 설명합니다.
    </P>
    <P>
      통화가 끝나면 대화방에 <UI>📞 통화 종료 • 3분 12초 • 참가자 2명</UI> 형태의 기록이 남습니다. 참가자 수는 통화
      중에 한 번이라도 들어온 사람 수입니다. 부재중 전화 목록은 따로 없으며, 아무도 받지 않은 통화도 같은 형태로
      기록됩니다.
    </P>

    <Sub>통화가 잘 안 될 때</Sub>
    <Table
      head={['증상', '원인과 해결']}
      rows={[
        [
          <UI key="a">이 주소에서는 카메라·마이크를 쓸 수 없어 보기 전용으로 연결합니다.</UI>,
          '보안 연결이 아닌 주소(http://)로 접속한 경우입니다. PC 앱을 쓰거나 https:// 주소로 접속하면 카메라와 마이크가 켜집니다',
        ],
        [
          <UI key="b">카메라·마이크 권한이 없어 보기 전용으로 연결합니다.</UI>,
          '웹은 주소창 옆 자물쇠 아이콘(사이트 설정)에서, PC 앱은 Windows 설정 > 개인 정보 및 보안 > 카메라·마이크에서 허용한 뒤 다시 거세요. 카메라나 마이크 하나만 막혀 있으면 그 장치만 빼고 연결됩니다',
        ],
        [
          <UI key="c">카메라를 다른 프로그램이 쓰고 있어 카메라 없이 연결합니다.</UI>,
          '다른 화상회의 프로그램처럼 카메라를 쓰고 있는 프로그램을 닫고 다시 거세요',
        ],
        [
          <UI key="c2">카메라·마이크가 없어 보기 전용으로 연결합니다.</UI>,
          '장치가 제대로 연결되어 있는지 확인합니다. 장치가 없어도 상대 화면과 소리는 받을 수 있습니다',
        ],
        [
          <span key="e">
            상대 소리가 안 들리고 <UI>소리 켜기</UI> 버튼이 보임
          </span>,
          '브라우저가 소리 자동 재생을 막은 경우입니다(주로 휴대폰). 버튼을 누르면 소리가 나옵니다',
        ],
        [
          <UI key="d">상대방이 응답하지 않습니다.</UI>,
          '아무도 30초 동안 받지 않으면 자동으로 종료됩니다. 잠시 후 다시 걸어보세요',
        ],
        [
          <UI key="e">이 채널의 멤버가 아니어서 통화할 수 없습니다.</UI>,
          '대화방에서 나간 뒤에 통화를 시도한 경우입니다',
        ],
        [
          <UI key="f">통화 인원이 가득 찼습니다(최대 6명).</UI>,
          '이미 6명이 통화 중입니다. 누군가 나가면 다시 참여할 수 있습니다',
        ],
        [
          <UI key="f2">통화 인원이 가득 차 초대하지 못했습니다(최대 6명).</UI>,
          '통화에 있는 사람과 호출 중인 사람을 합쳐 6명입니다. 누군가 나가거나 호출이 끝나면 다시 초대할 수 있습니다',
        ],
        [
          <UI key="f3">○○○님을 초대하지 못했습니다. 상대가 PC 앱을 업데이트하면 초대할 수 있습니다.</UI>,
          '게스트로 부르려는 사람의 PC 앱이 오래된 버전입니다. 앱을 다시 실행하면 자동으로 업데이트됩니다',
        ],
        [
          <UI key="g">다른 기기에서 이미 이 통화에 참여하고 있습니다.</UI>,
          '같은 계정으로 다른 PC나 휴대폰에서 이 통화에 들어가 있습니다. 그 기기에서 나간 뒤에 참여하세요',
        ],
        [
          <span key="h">
            상대 화면에 <UI>연결하지 못했습니다</UI>가 보임
          </span>,
          '그 사람과의 영상 연결이 여러 번 끊긴 경우입니다. 화면의 다시 연결을 누르고, 그래도 안 되면 유선 네트워크에서 다시 들어오세요',
        ],
        ['화면은 연결됐는데 상대가 안 보임', '회사 방화벽이나 VPN이 영상 연결을 막고 있을 수 있습니다. 유선 네트워크에서 다시 시도해 보세요'],
      ]}
    />
    <Callout tone="info" title="여러 명이 통화할 때">
      <p>
        인원이 많아질수록 PC와 네트워크 부하가 커집니다. 6명을 넘는 회의나 회사 밖 사람이 참여하는 회의는 사내 화상회의
        도구를 쓰세요.
      </p>
    </Callout>
  </>
);
